var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { setWatermark } from 'app/assets/brands/Logo';
import { errorNotifier } from 'app/utils/error';
import { fetchSigned } from 'app/utils/network';
export const loadProfile = createAsyncThunk('editor/profile', (_, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const profile = yield fetchSigned('/api/profile');
        setWatermark(window.atob(profile.watermark.source));
    }
    catch (_error) {
        errorNotifier(_error);
    }
}));
